import React, { useEffect, useState } from 'react';

import * as S from './style';

function LinearProgressBar({
  backgroundColor = '#e5e5e5',
  visualParts = [
    {
      percentage: '0%',
      color: 'white'
    }
  ]
}) {
  const [widths, setWidths] = useState(visualParts.map(() => 0));

  useEffect(() => {
    requestAnimationFrame(() => {
      setWidths(visualParts.map(item => item.percentage));
    });
  }, [visualParts]);

  return (
    <S.LinearProgressBarWrapper>
      <S.ProgressVisualWrapper
        style={{
          backgroundColor
        }}
      >
        {visualParts.map((item, index) => (
          <S.ProgressVisualPart
            key={index.toString()}
            style={{
              width: widths[index],
              backgroundColor: item.color
            }}
          />
        ))}
      </S.ProgressVisualWrapper>
    </S.LinearProgressBarWrapper>
  );
}

export { LinearProgressBar };
